import { isEqual, mapValues, omit, sum } from 'lodash';
import { isOfType, unreachable } from '../../../../ts-utils';
import { getNextChunkState } from './comments-paging-selectors';
function getResourcePaginationState(resourceState) {
    if (!resourceState) {
        return { type: 'NONE' };
    }
    switch (resourceState.type) {
        case 'PENDING': {
            return {
                type: 'PENDING',
                lastTotals: resourceState.lastTotals,
                pageSize: resourceState.configs.pagination.initialPage.commentLimit,
                ordering: resourceState.configs.pagination.ordering,
            };
        }
        case 'ERROR': {
            return { type: 'ERROR' };
        }
        case 'READY': {
            return getResourcePaginationStateReady(resourceState);
        }
        default: {
            throw unreachable(resourceState);
        }
    }
}
const getResourcePaginationStateReady = (resourceState) => {
    const fetchedChunks = resourceState.topLevelCommentList.chunks.filter(isOfType('FETCHED'));
    return {
        type: 'READY',
        totals: resourceState.totals,
        count: sum(fetchedChunks.map((c) => c.commentIds.length)),
        ordering: resourceState.configs.pagination.ordering,
        endIsReached: getNextChunkState(resourceState).type === 'NONE',
    };
};
export const getCurrentPaginationState = (state) => mapValues(state, getResourcePaginationState);
export const createPaginationWatcher = (store) => {
    let onChange;
    return {
        getCurrent: () => getCurrentPaginationState(store.getState().comments),
        onChange: (callback) => {
            if (onChange) {
                onChange = callback;
                return;
            }
            onChange = callback;
            let lastState = getCurrentPaginationState(store.getState().comments);
            store.subscribe(() => {
                const currentPaginationState = getCurrentPaginationState(store.getState().comments);
                if (!isEqual(currentPaginationState, lastState)) {
                    lastState = currentPaginationState;
                    onChange?.(currentPaginationState);
                }
            });
        },
    };
};
export function shouldFetchComments(newPagination, resourceCommentsState) {
    if (!resourceCommentsState) {
        return true;
    }
    switch (resourceCommentsState.type) {
        case 'ERROR': {
            // Always allow refetch on error;
            return true;
        }
        case 'PENDING': {
            // Refetch only if pagination config is different, here we do not need to accout for internally loaded additional chunks
            return !isEqual(newPagination, resourceCommentsState.configs.pagination);
        }
        case 'READY': {
            const resourcePagination = resourceCommentsState.configs.pagination;
            if (!isEqual(omit(newPagination, 'initialPage'), omit(resourcePagination, 'initialPage'))) {
                return true;
            }
            // Here we decide not by strict object equality, but by the result of the the fetch
            const paginationState = getResourcePaginationStateReady(resourceCommentsState);
            // Now we have situation with loaded chunks
            if (paginationState.count === newPagination.initialPage.commentLimit) {
                // We have same amout of comments - pagination is identical
                return false;
            }
            else if (
            // We go less comments than newPagination asks, but is it possible to get more? If the answer is no - there is no need to refetch
            paginationState.count < newPagination.initialPage.commentLimit &&
                paginationState.endIsReached) {
                return false;
            }
            return true;
        }
        default:
            throw unreachable(resourceCommentsState);
    }
}
//# sourceMappingURL=comments-paging-watcher.js.map